
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoqSgt1h6rjH4GtqDQd_IOZkAon1YE3x32pFgVA4JmwB4Meta } from "/var/www/2025-07-09_15_09/pages/edo.vue?macro=true";
import { default as help21ZJolXZyKZpEjVqY5eBeiUjEJJQnEUrhO3EhzcimbUMeta } from "/var/www/2025-07-09_15_09/pages/help.vue?macro=true";
import { default as cargo2inCqNL9664ZYxoPZaX8iP1zOCFpquB0vaVsGrmHMcUMeta } from "/var/www/2025-07-09_15_09/pages/cargo.vue?macro=true";
import { default as indexfzsJC64UI8FXx16fq49SffL7GN4JG4vsMNAv4yqXIYYMeta } from "/var/www/2025-07-09_15_09/pages/index.vue?macro=true";
import { default as _91slug_93yQ0c8CHabFMhbbmpQcufMQbHv9oqUbmxdbjMxOYoVvsMeta } from "/var/www/2025-07-09_15_09/pages/[slug].vue?macro=true";
import { default as cookieDDjAVPE5kGuynAt0dOiIhDV3smfSNkz3oXf4QlZXT_450Meta } from "/var/www/2025-07-09_15_09/pages/cookie.vue?macro=true";
import { default as belarusT9aLG7Uila2r3D1glf3IAm5FybPozMTR3tdmzCxgnEEMeta } from "/var/www/2025-07-09_15_09/pages/belarus.vue?macro=true";
import { default as bonusesCyFQ_w1L8Fl9mI_nHax39aYLY1lO2unNEznWX_45GT5RQMeta } from "/var/www/2025-07-09_15_09/pages/bonuses.vue?macro=true";
import { default as api01ujBWvUwxmRTemzeXzQI3Pm_454ftmyZn0VidM366MoIMeta } from "/var/www/2025-07-09_15_09/pages/dev/api.vue?macro=true";
import { default as cmsK9r7xC3KSHgTBU8d18eC13DJfIYckoB9pY1VLAFRiP8Meta } from "/var/www/2025-07-09_15_09/pages/dev/cms.vue?macro=true";
import { default as konkursWdlgXYKWxdm3QQv_45HEtXRgTcq0ryTFqLSnq6BcMRkaoMeta } from "/var/www/2025-07-09_15_09/pages/konkurs.vue?macro=true";
import { default as successxjxztxCEZdvkpEl_R0XHbAEenZDiFwPvFGRQs7rU2nUMeta } from "/var/www/2025-07-09_15_09/pages/success.vue?macro=true";
import { default as tariffs_UQi1lSVBLH4pazOu4FO5fw02_45agAgLdKceZO9ti6YwMeta } from "/var/www/2025-07-09_15_09/pages/tariffs.vue?macro=true";
import { default as vacancyplDsU_45iH_iE1oKWDyva3Y6yRi_45la1LGyf05y3r42B10Meta } from "/var/www/2025-07-09_15_09/pages/vacancy.vue?macro=true";
import { default as contactsFJwVK1T_45piwHzGQyAcLAYd_45EzOtRzskTok4gqB_45zqf4Meta } from "/var/www/2025-07-09_15_09/pages/contacts.vue?macro=true";
import { default as giveawaytkC_kCo6c6k8ggQnmwpnhS3UFnpwAyhkKLgVYsof_xEMeta } from "/var/www/2025-07-09_15_09/pages/giveaway.vue?macro=true";
import { default as guide_45lk0SJDLjiDGDh5CsyuoNAX_45P_BgixEk98uHEpXIiDLzhQMeta } from "/var/www/2025-07-09_15_09/pages/guide-lk.vue?macro=true";
import { default as servicesqzAkmMRL1jpW5_OGrGlV9KuRcpuVx_oSMuq5NIlJxgQMeta } from "/var/www/2025-07-09_15_09/pages/services.vue?macro=true";
import { default as telegramyunpUAxoxekBb22qYIy69A7CCK9AdMA9ZJyW6_45E5B_45IMeta } from "/var/www/2025-07-09_15_09/pages/telegram.vue?macro=true";
import { default as documentsbaT1wBXdHk8JDW2BCk7MN4_45acNwfC5A2a_45atm4kkkRcMeta } from "/var/www/2025-07-09_15_09/pages/documents.vue?macro=true";
import { default as franchiseYZ7hfJrICF1ykqVaFQrJyvWt0bEXNiGwrBeq5jGy3hEMeta } from "/var/www/2025-07-09_15_09/pages/franchise.vue?macro=true";
import { default as insuranceDvFNCy1wPr1z8pJ76dcBPfWjIjzgLv_7YWugG4n4lEgMeta } from "/var/www/2025-07-09_15_09/pages/insurance.vue?macro=true";
import { default as kirghiziaVtmfwRIO_45RlV9X_45zPESI4mSy9ZUUjb8xHr6gWAA_45U28Meta } from "/var/www/2025-07-09_15_09/pages/kirghizia.vue?macro=true";
import { default as mapSchemewvCBP__45dFlV2bhkHRHGWl42VMV3rXMfcbb4EjmDU7_45oMeta } from "/var/www/2025-07-09_15_09/pages/mapScheme.vue?macro=true";
import { default as _91id_93ZJrmA6DiatQZ6s9dhjSeQRA8Mx5iUO9Ju98Gv_yiPEMMeta } from "/var/www/2025-07-09_15_09/pages/news/[id].vue?macro=true";
import { default as return_45sdbyWR5GnQ_jbpKI3T3aVBm93GtKSmafcPprK3_45DG1GF0Meta } from "/var/www/2025-07-09_15_09/pages/return-sd.vue?macro=true";
import { default as smsClientwXLHUssZ2iQDEPIkr0llrh4g1LT4Y0OqPhbZG5w7btUMeta } from "/var/www/2025-07-09_15_09/pages/smsClient.vue?macro=true";
import { default as terminalsj2Nv1l2Lb1AWQEAk55sAXtzN_qSkyWo9g4H4pItk6UUMeta } from "/var/www/2025-07-09_15_09/pages/terminals.vue?macro=true";
import { default as iframeWDs2c3RuKpWpVp_rEI1IsWGVr2L_wzgqeO4Hx8C4498Meta } from "/var/www/2025-07-09_15_09/pages/dev/iframe.vue?macro=true";
import { default as directionspUjgOjECK9TkcVB5S4nfGECFUf6ozeMjtOe_45eq38zdMMeta } from "/var/www/2025-07-09_15_09/pages/directions.vue?macro=true";
import { default as kazakhstanwUWY4Rq036rZcZtjVioGO3WTFBR69mfFBL0s_GDT_5QMeta } from "/var/www/2025-07-09_15_09/pages/kazakhstan.vue?macro=true";
import { default as index98cdjU2IqrOlySxLClz75_45W_RKyIgQsNjRglp4wUuNoMeta } from "/var/www/2025-07-09_15_09/pages/news/index.vue?macro=true";
import { default as svgpEWj0Jjm9L5LqdtbCKAIfo7qbYOGZIWsXM9JDXhIoc4Meta } from "/var/www/2025-07-09_15_09/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45fail6R8IuXFDIMjdIJVcAb_45sP9iM_45PWPx4_bkV_45TPYFugdwMeta } from "/var/www/2025-07-09_15_09/pages/vzpay-fail.vue?macro=true";
import { default as constructorrLbWmw1Wu3FcUosntUtFPvlowqjHX2Avdr2skrEKCDAMeta } from "/var/www/2025-07-09_15_09/pages/constructor.vue?macro=true";
import { default as indexL0Ow88lwwkHMCagXOaI1hfngvQCH2QHzI0csEF_45npjEMeta } from "/var/www/2025-07-09_15_09/pages/gifts/index.vue?macro=true";
import { default as informationP3wESdBGAEFayIvLXEEYXlt_454L4vhOdPzvJv4iGl47gMeta } from "/var/www/2025-07-09_15_09/pages/information.vue?macro=true";
import { default as light_B1cIGQbodabxGz5XJ_45otAqNDFd7RTgR4WJBGcNrn_45EMeta } from "/var/www/2025-07-09_15_09/pages/order/light.vue?macro=true";
import { default as claim_45filing7hK4rCxHqonY_45y2_dJzGzEHSNgFYkJt_shu2qKVsGyEMeta } from "/var/www/2025-07-09_15_09/pages/claim-filing.vue?macro=true";
import { default as _91type_93OTtg5X9uK5pzUoCb2LJvIKyws57GQPiVjjNZSTz6VYgMeta } from "/var/www/2025-07-09_15_09/pages/gifts/[type].vue?macro=true";
import { default as marketplacesC40NnPRkH135UF0cuUP8_HqeT9H5bbmZ_45rAPen_45R3pgMeta } from "/var/www/2025-07-09_15_09/pages/marketplaces.vue?macro=true";
import { default as networkshops9BXqdIXTs5SB_45kk8h_45JBvGkH9CRl0pHdipMN8kkSTsMMeta } from "/var/www/2025-07-09_15_09/pages/networkshops.vue?macro=true";
import { default as online_45storeKC797yFH41aFVtk2dUtn1Ml_JfDHniVXLKaQL0G1ePIMeta } from "/var/www/2025-07-09_15_09/pages/online-store.vue?macro=true";
import { default as manage_45cyAZPvaDwomTES9_BiGZb3NXrM6gOKP5r_45vTEjQVUQMeta } from "/var/www/2025-07-09_15_09/pages/order/manage.vue?macro=true";
import { default as registrationJBAEZXamBoLw8bVLpaSWpvTbbV8Cb6ZjbU_45pfdBcce0Meta } from "/var/www/2025-07-09_15_09/pages/registration.vue?macro=true";
import { default as run_45schedule_FQeD4V9jeGss11XbP_45_45D6k2bjDSZafHq51HAD4mbRoMeta } from "/var/www/2025-07-09_15_09/pages/run-schedule.vue?macro=true";
import { default as safe_45custodyY_45OSQXawEqB0t0B29SChUrIPV1ylIjYP9I2CnwGZOJcMeta } from "/var/www/2025-07-09_15_09/pages/safe-custody.vue?macro=true";
import { default as imageRMFpMEP9e6rQnV0P3JTcsVan3bsmpFVeDceOk65rwY4Meta } from "/var/www/2025-07-09_15_09/pages/ui-kit/image.vue?macro=true";
import { default as indexKFRTnGx_UFEw6og1bpcysltOt3CZlYAbGiatv5uBRtgMeta } from "/var/www/2025-07-09_15_09/pages/ui-kit/index.vue?macro=true";
import { default as bagrAb7RShu01Ibfl3GhoJwck3xhHkvy8_H2RaNGbIi0jIMeta } from "/var/www/2025-07-09_15_09/pages/wrapping/bag.vue?macro=true";
import { default as boxbNQaw2a7LPeUo68nxRXxn7Fi6McAfO50fLAMD2ZMK3cMeta } from "/var/www/2025-07-09_15_09/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingJON624sP3Zcp_QXM41vXbk6Hx8y6_JOSwr2Wq_45D1SEkMeta } from "/var/www/2025-07-09_15_09/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayY_45RUzmGOtnHbkGu40BAB2OxitgfCEkJy92IzhVat6psMeta } from "/var/www/2025-07-09_15_09/pages/happybirthday.vue?macro=true";
import { default as manageGuGnL518ko43tZeSh_45oX6bJKTK2Jln_45NunTh90atzs4Meta } from "/var/www/2025-07-09_15_09/pages/iframe/manage.vue?macro=true";
import { default as autho5Z9GEfO1zeX72oBzEV8bK81DvDScYY9vP0S_45Q_45WFjsMeta } from "/var/www/2025-07-09_15_09/pages/personal/auth.vue?macro=true";
import { default as publicaEFC0akGpBR0L15DP2InhU46fMfW7EH29lH6w7TBW44Meta } from "/var/www/2025-07-09_15_09/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerxnnhh4mNmeTFSUkCtoOHAvrMvVOsNgbvb4HOvdb29NEMeta } from "/var/www/2025-07-09_15_09/pages/already-answer.vue?macro=true";
import { default as tariffsFT8N4tg0b1j5XxGr4PaJzzIyFBC8KeqW2ERh1wKOxIgMeta } from "/var/www/2025-07-09_15_09/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93rHIWsHk1BNI_45Sd52BiMvPfaZE6qFI6uwldBnLjfRtWIMeta } from "/var/www/2025-07-09_15_09/pages/order/pay/[id].vue?macro=true";
import { default as indexGIhN995pqEL1UTfEedgHpTDxwlgZ7oJwUB20DFjSSWIMeta } from "/var/www/2025-07-09_15_09/pages/personal/index.vue?macro=true";
import { default as privacy_45policygT5R3ekLFM0PqByVK_45twZ_45XEAcFokEdxHqkozQFkRQAMeta } from "/var/www/2025-07-09_15_09/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93PXOIfezVM42K3cHU3vePhUfr59k2c_45S3lxynuGIB_1YMeta } from "/var/www/2025-07-09_15_09/pages/welcome/[hash].vue?macro=true";
import { default as indexn5Z1kKYrtEuy6Wx0scsy3m43j19TQAmMb3HjM8Q_45AUIMeta } from "/var/www/2025-07-09_15_09/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiaNF9cq69rIC61Ms2twJTDshu825dJxiT_OFvI2tW7zIcMeta } from "/var/www/2025-07-09_15_09/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodssToL5qAkoGo7wGXgMqEJF5Ixt7RaI6JlhBqCuvDwvNEMeta } from "/var/www/2025-07-09_15_09/pages/payment-methods.vue?macro=true";
import { default as qr_45info_45DaCAnMpEJoGz7I7Gqy2xZuksYMQQMXFb90QDosk3RAMeta } from "/var/www/2025-07-09_15_09/pages/payment/qr-info.vue?macro=true";
import { default as successThphU_Q4Sc6fqnpOGv8Ch0RLQoOA2ms5RgzH1vYO1YoMeta } from "/var/www/2025-07-09_15_09/pages/payment/success.vue?macro=true";
import { default as importLl_4563B_459CIIc7_45azX60BK7pYnSzqG1o_45iIxJ8lliF0MMeta } from "/var/www/2025-07-09_15_09/pages/personal/import.vue?macro=true";
import { default as logout9kcK5JlZ8p8XU9UQHC4vRpJHtFu6fSV4tORB9ckdUnYMeta } from "/var/www/2025-07-09_15_09/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryu9SSfS71CbcZKHrNYqKI6CbCPdxvb0dtpEWcTc0bWcsMeta } from "/var/www/2025-07-09_15_09/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45delivery3hguyifzSXhomILH74oFJ148JAbWK8OwRFfwh2zHJ14Meta } from "/var/www/2025-07-09_15_09/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024vPTKirfRgbIMTZC9NtIX2A9Nee6uaFTKoh450fdkVA4Meta } from "/var/www/2025-07-09_15_09/pages/happynewyear2024.vue?macro=true";
import { default as ozonq5dsBq4D3chuODD17vL9gEEKbHZwn0teQ_45u_3ASeEk0Meta } from "/var/www/2025-07-09_15_09/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failtYH9Ri2KeGBkER1wYPFrTuDcH0i0sWAPeU8CkmOUAWIMeta } from "/var/www/2025-07-09_15_09/pages/payment/pay-fail.vue?macro=true";
import { default as accountuPm5UM6pirXN4WzV3NF5mKKsdpNMsqlv1lBBx8XOpnEMeta } from "/var/www/2025-07-09_15_09/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsHWiZa6041uZimNnyMCH6rNogR2VF_4v7iRLqKkZbckkMeta } from "/var/www/2025-07-09_15_09/pages/prohibited-goods.vue?macro=true";
import { default as directiont4AqAmAKSJpOTMIpkawc_22PC3XZ7p78TKG_76a0oWcMeta } from "/var/www/2025-07-09_15_09/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupyJNSrEYE_VVG3QNrgNolUue_I0IAAslxaqCGMD27MdcMeta } from "/var/www/2025-07-09_15_09/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoWosY4FydZ0b3JkhsWlhMc3eZg9RXhFTHNDIi_gSuVZUMeta } from "/var/www/2025-07-09_15_09/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorTbStLdD_452wAVUDvgO9FeIETYmVJJQl5uWf9E90zkXQgMeta } from "/var/www/2025-07-09_15_09/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonuseszcjhy1BV_45izXsi2IYUWILk4_45Zrl67cESqZK1TqORffIMeta } from "/var/www/2025-07-09_15_09/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93o8YRV0tGGqEY4Reka431kSCv6E8IzFRcIKraqZWIsKIMeta } from "/var/www/2025-07-09_15_09/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoTnt1QZOMx4837QumBxmvU1O4LC_45VWLTvOju_45go9kHWEMeta } from "/var/www/2025-07-09_15_09/pages/payment/card-info.vue?macro=true";
import { default as discount1L4lANrmI9rjAscSCsKMRbIrxQSf43W3IxyO2KkI5RcMeta } from "/var/www/2025-07-09_15_09/pages/personal/discount.vue?macro=true";
import { default as hard_45boxPUAoOp5ZLU05rrtt2mNmIpNg8MTktFBf2mwlTTODv_45cMeta } from "/var/www/2025-07-09_15_09/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptgY2gVo9048uMm5PWS8rJ_456z8ykCuqrl10E1_45o_45GhOTAMeta } from "/var/www/2025-07-09_15_09/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917RvqjjlxCLBkR8l_45RStNIK182OouhyFsHX_45CtMnU5UtsMeta } from "/var/www/2025-07-09_15_09/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationSIuEqkBF8VPATEmfuzirFcVyPmjY3035lA0lp7Q0T9gMeta } from "/var/www/2025-07-09_15_09/pages/mobile-application.vue?macro=true";
import { default as indexa8fb2HQH7twhB8I_45DHCPheKTdSiRKp0GlYxBEXn9WcAMeta } from "/var/www/2025-07-09_15_09/pages/order/create/index.vue?macro=true";
import { default as boatZE64H1jSljrGUPYl_LReRSmuCAkZbEn5CZe2qMuVwEwMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/boat.vue?macro=true";
import { default as sofapr84tdQaCn5Ir1Wtz0NgI6i1J1NFrRhqTmo_mkpGCiYMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardVMtFhsHpP2xplGissjoe0pJVQaGpHz1vpSaZYhPQOA0Meta } from "/var/www/2025-07-09_15_09/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesO75HSJlOSd98gGlm1jFGbhSNJxyBY1xZTHNxAc_45ylIIMeta } from "/var/www/2025-07-09_15_09/pages/personal/promocodes.vue?macro=true";
import { default as benchXzbEMbx049zm15W4Rn_45iSejsSgdruOpeQjUER3h8xHMMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/bench.vue?macro=true";
import { default as booksAdi7IiZZhJLjEulFUBkv1owHMWpBIFX3XtD_45X_I7f8cMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/books.vue?macro=true";
import { default as cableBBAiLjBeMiZavYhw33xKkVYv5x6ERIXdQvRzJwoKub0Meta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/cable.vue?macro=true";
import { default as chairW3AeB0Btd2B2mxNR4iXul2Dkw4QTq1iXakQtudBLxz8Meta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsQyheb7GkY7uzJBjMixMtMZeI59HDJv5pTreTAYvOERkMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/goods.vue?macro=true";
import { default as indexhaksSazR6qlIHMywpbDndHWPDUvwu0LQRjPfT12KZVwMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/index.vue?macro=true";
import { default as metalDrnS9I_eIDTJeK9IetCpgplGYtvaTA2DniRDLy_LZYcMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoDp11nL9ybeeHZNB9PyEEyod11m1puf8a_45ZvAAtCNZMEMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesQp6oKadZHFEnGVBT_45NOKts6hQ_LgukSQj4LIjXg4mZ4Meta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsipKHvRrjpRkrtx7R049CbyATX1G7oqY6itma1ypblqUMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxaKXgKN7LYCRLki_9GticyWQTcRRbsHo3CQOTO1Gf9qsMeta } from "/var/www/2025-07-09_15_09/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93_457PFR8CnoDS_Y5hCVz3hsYEHdiRFmKleyU0VHyWnXfgMeta } from "/var/www/2025-07-09_15_09/pages/personal/bonus/[tab].vue?macro=true";
import { default as print70cMAb3DA122tiYzlGxTIxe1L__l2l6qDr22RbAFDdQMeta } from "/var/www/2025-07-09_15_09/pages/personal/order/print.vue?macro=true";
import { default as dishesdxMqOcF4oBzBsYYv1a5Txj88gffgBR83cfs6nLi6rQ4Meta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/dishes.vue?macro=true";
import { default as enginexIpGqLVgGrqs7Hh0yx2Ucx9_0QdnFrC8tbnouwGYLDEMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberVRcKPvV9_45tP9zTM9t_45CG3jHA_zzzaxQvMMPN4bb7MUIMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheels75vYPfiWJ4TkYeZPmUgYwT4jbIZMnBZnLxQW9FUT0RwMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmLl1fvcUsWhI32o2pepUU1OdQJvzR_ICCtDYANNm87D4Meta } from "/var/www/2025-07-09_15_09/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingATcs4Y7wgnBqzhEkD22HfCDhiuaBHyZujT9FwZxfYkUMeta } from "/var/www/2025-07-09_15_09/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalWtzLf_LgX3nMrRYYnzlBvqsO9_T5HsKL1azJiiyM0j0Meta } from "/var/www/2025-07-09_15_09/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93UvxpU7Y9WrfNd8GT2otMwWTVinzx2WA_45AoDim0PGi0AMeta } from "/var/www/2025-07-09_15_09/pages/personal/order/[guid].vue?macro=true";
import { default as createGOiG8Yd67gF2PQ41hB_45QGUPzU6TDJZWSZvdxz2Xh9t8Meta } from "/var/www/2025-07-09_15_09/pages/personal/order/create.vue?macro=true";
import { default as barrelsHJ76I4HRfHuD_dn9eIH5KW7XGYz_PSgaUolRD8THK9UMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothes_45tMpBGNp2PdPTHrAyfT3H_fZKEPXXv8dyKJ8PQbMjVgMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragiletDr0I9bgJPDBxNFh7sGhXdRzFv20SQU1Nk3Ql_YYch4Meta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerTOc3O7uZKbD8tO1_q_45itLdzcDqjuIyLQEHCu3_v9DrkMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packageCfylXNiBoCnMQwR1IKblsHdc8fbKfNnZWIs5ptmuv7IMeta } from "/var/www/2025-07-09_15_09/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successx0nrXkzx2X0wSSXUwF77ZwkCxyL5QTkGH_DmbraG5oUMeta } from "/var/www/2025-07-09_15_09/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagedCcYHUStiVQ5mwWzi9i8LmhLPR_vmJVaHpAfa8f7_45uQMeta } from "/var/www/2025-07-09_15_09/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesz3O4heztajhQyvYwHyEl_455mXuM7aYEP6j8KXdCOotrsMeta } from "/var/www/2025-07-09_15_09/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93kujygrZ7Am5I0v37NEMGMo4uXamAa1akiakR8Mt_45tPYMeta } from "/var/www/2025-07-09_15_09/pages/order/administer/[guid].vue?macro=true";
import { default as furnitureR5tD8GDx48yUliqOqXejwHUg3sBVV3eJ7DgUqTqF8XYMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversized_m_455kqFgH70Zdi0B04_zZqDysK_T8Pk0LNA4rJA8QzYMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeoitZf0zPMDppoRGuAjEUIg13B72NAfDp3JlXsslkxpIMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93a5oYhvSWbpPcDnzG3Iyo0GgvFn7aK4FokX3NSNcdRhEMeta } from "/var/www/2025-07-09_15_09/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93UeY_459IeOsN_45SPT1HMByg97oDTKGekMf6h94jQF2k_45uMMeta } from "/var/www/2025-07-09_15_09/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsLTEh03COx8AqQDo8b5WlkdZKiOTwr_45mN993rC_45z9Hb4Meta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspaperspe1RN8yC_45KIWNpMyy1ccTUzGDke_WTqeMmCsUpXQ96gMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargoOgWa93ydiHU_s2kcK3HabeqF0R_XcposGh7RRXjbtp0Meta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobileyLnjR2wdrxKd4DWuVgIbFLVvfmXzEZ2HNIy45lQ9oGYMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexVrnC_3jkRdCGJcxZ6_IeOSZFmQv_ZW5L9ttnvbBdNLgMeta } from "/var/www/2025-07-09_15_09/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketvisXRHyf62M8oFooiLTk_Y1jxORpEv2_XWedcmJ0DDsMeta } from "/var/www/2025-07-09_15_09/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesnxE_9zZ55J97saHtFjIzNtmdENTGA0z0ZDdrSO7IIUgMeta } from "/var/www/2025-07-09_15_09/pages/personal/orders/templates.vue?macro=true";
import { default as indexkNHCyB_45_IwL2sG2tPh8Y2scXOf76_86Nlyt9ubhF_45voMeta } from "/var/www/2025-07-09_15_09/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorYAxFjpWeOxQdhl1fTT1hOY5e6HCnkPWoNK4GjlJctTQMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93eabjbfCTGPCowYjULAZNBMY_45g8An2J3YcAAvBFELJEAMeta } from "/var/www/2025-07-09_15_09/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexYWVaPga63omoIVgMp5Gqs7pndAoTTyAX_45KylMdlIhN0Meta } from "/var/www/2025-07-09_15_09/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93aJKz5c4bkXYw4NSfh3Dibtrqe87iRbLN5LaLZm0LJ9gMeta } from "/var/www/2025-07-09_15_09/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goods0fJq_n0R1sgoCum_45C8REMSRbrk66ypmAIOAqQ3fw9lYMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexY_45m6ghoAso_QPftBFCyEXO_454TV4C9_45JxB0Em91ySnfoMeta } from "/var/www/2025-07-09_15_09/pages/personal/group-printing/index.vue?macro=true";
import { default as index2lmCnpqEr0q8Bo0U5PcmTBH_452orBO1CHqZ9vmd2u_S4Meta } from "/var/www/2025-07-09_15_09/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicesIEqyskuvCmiSaRZ9JPP_BrxwsaaGw4Gg8_45v95L6RlocMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93yF74OfhlvrAwLcm45_459fQjoihrzheGtZ_45QNjJxwd9GMMeta } from "/var/www/2025-07-09_15_09/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93IPoVZWHEAk4hKczYboDMuqWDlyLnxb6XtG_EAA77dxkMeta } from "/var/www/2025-07-09_15_09/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93MFs_bG5_SMKIE5Nu1uXZb5bnTOgf9sq3a6kcfOSEaloMeta } from "/var/www/2025-07-09_15_09/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipment7TMOpzwz3_45L5A33W_45CNBsv82YIOK1UyxPkKCQz_45ua8gMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsIs3_HZ0b5Q718w20GJ1bvid6Hfmpf3Qp8vd9GQLl2_oMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsvR4__45zHTaA559rojrizakJiIWKBz5lXCw4RJbShKtY4Meta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipment5tpS4EIXkCY8BdhHCzqtfaFc17ByWLHEywLaT2ARSyoMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationzDbHJpXy7auzcKgPlVeLJkmtg2GAVqTW5twhsli1olQMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93H_v66OKc0NCLGGmG8vo2Xrh1dkClqrSN8LLlIIM8gwgMeta } from "/var/www/2025-07-09_15_09/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationUFOaiPUFwav16XT3wDEMSxQe8mL3jCG2AFI_45ZpbqNsEMeta } from "/var/www/2025-07-09_15_09/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-07-09_15_09/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-07-09_15_09/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-07-09_15_09/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-07-09_15_09/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93yQ0c8CHabFMhbbmpQcufMQbHv9oqUbmxdbjMxOYoVvsMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-07-09_15_09/pages/cookie.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-07-09_15_09/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-07-09_15_09/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-07-09_15_09/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-07-09_15_09/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursWdlgXYKWxdm3QQv_45HEtXRgTcq0ryTFqLSnq6BcMRkaoMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-07-09_15_09/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-07-09_15_09/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-07-09_15_09/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsFJwVK1T_45piwHzGQyAcLAYd_45EzOtRzskTok4gqB_45zqf4Meta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-07-09_15_09/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-07-09_15_09/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-07-09_15_09/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-07-09_15_09/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-07-09_15_09/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-07-09_15_09/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-07-09_15_09/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-07-09_15_09/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemewvCBP__45dFlV2bhkHRHGWl42VMV3rXMfcbb4EjmDU7_45oMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93ZJrmA6DiatQZ6s9dhjSeQRA8Mx5iUO9Ju98Gv_yiPEMMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-07-09_15_09/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-07-09_15_09/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-07-09_15_09/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-07-09_15_09/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-07-09_15_09/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-07-09_15_09/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: index98cdjU2IqrOlySxLClz75_45W_RKyIgQsNjRglp4wUuNoMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-07-09_15_09/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-07-09_15_09/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorrLbWmw1Wu3FcUosntUtFPvlowqjHX2Avdr2skrEKCDAMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexL0Ow88lwwkHMCagXOaI1hfngvQCH2QHzI0csEF_45npjEMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-07-09_15_09/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-07-09_15_09/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-07-09_15_09/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93OTtg5X9uK5pzUoCb2LJvIKyws57GQPiVjjNZSTz6VYgMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-07-09_15_09/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-07-09_15_09/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-07-09_15_09/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-07-09_15_09/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-07-09_15_09/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-07-09_15_09/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-07-09_15_09/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-07-09_15_09/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-07-09_15_09/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-07-09_15_09/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayY_45RUzmGOtnHbkGu40BAB2OxitgfCEkJy92IzhVat6psMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageGuGnL518ko43tZeSh_45oX6bJKTK2Jln_45NunTh90atzs4Meta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-07-09_15_09/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-07-09_15_09/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsFT8N4tg0b1j5XxGr4PaJzzIyFBC8KeqW2ERh1wKOxIgMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-07-09_15_09/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexGIhN995pqEL1UTfEedgHpTDxwlgZ7oJwUB20DFjSSWIMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-07-09_15_09/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-07-09_15_09/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-07-09_15_09/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-07-09_15_09/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-07-09_15_09/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-07-09_15_09/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importLl_4563B_459CIIc7_45azX60BK7pYnSzqG1o_45iIxJ8lliF0MMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logout9kcK5JlZ8p8XU9UQHC4vRpJHtFu6fSV4tORB9ckdUnYMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-07-09_15_09/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-07-09_15_09/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024vPTKirfRgbIMTZC9NtIX2A9Nee6uaFTKoh450fdkVA4Meta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonq5dsBq4D3chuODD17vL9gEEKbHZwn0teQ_45u_3ASeEk0Meta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-07-09_15_09/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountuPm5UM6pirXN4WzV3NF5mKKsdpNMsqlv1lBBx8XOpnEMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-07-09_15_09/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-07-09_15_09/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-07-09_15_09/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-07-09_15_09/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorTbStLdD_452wAVUDvgO9FeIETYmVJJQl5uWf9E90zkXQgMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-07-09_15_09/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-07-09_15_09/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-07-09_15_09/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discount1L4lANrmI9rjAscSCsKMRbIrxQSf43W3IxyO2KkI5RcMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-07-09_15_09/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917RvqjjlxCLBkR8l_45RStNIK182OouhyFsHX_45CtMnU5UtsMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-07-09_15_09/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexa8fb2HQH7twhB8I_45DHCPheKTdSiRKp0GlYxBEXn9WcAMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesO75HSJlOSd98gGlm1jFGbhSNJxyBY1xZTHNxAc_45ylIIMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93_457PFR8CnoDS_Y5hCVz3hsYEHdiRFmKleyU0VHyWnXfgMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: print70cMAb3DA122tiYzlGxTIxe1L__l2l6qDr22RbAFDdQMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-07-09_15_09/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93UvxpU7Y9WrfNd8GT2otMwWTVinzx2WA_45AoDim0PGi0AMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createGOiG8Yd67gF2PQ41hB_45QGUPzU6TDJZWSZvdxz2Xh9t8Meta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-07-09_15_09/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-07-09_15_09/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesz3O4heztajhQyvYwHyEl_455mXuM7aYEP6j8KXdCOotrsMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-07-09_15_09/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-07-09_15_09/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93UeY_459IeOsN_45SPT1HMByg97oDTKGekMf6h94jQF2k_45uMMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexVrnC_3jkRdCGJcxZ6_IeOSZFmQv_ZW5L9ttnvbBdNLgMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketvisXRHyf62M8oFooiLTk_Y1jxORpEv2_XWedcmJ0DDsMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesnxE_9zZ55J97saHtFjIzNtmdENTGA0z0ZDdrSO7IIUgMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexkNHCyB_45_IwL2sG2tPh8Y2scXOf76_86Nlyt9ubhF_45voMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93eabjbfCTGPCowYjULAZNBMY_45g8An2J3YcAAvBFELJEAMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexYWVaPga63omoIVgMp5Gqs7pndAoTTyAX_45KylMdlIhN0Meta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93aJKz5c4bkXYw4NSfh3Dibtrqe87iRbLN5LaLZm0LJ9gMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexY_45m6ghoAso_QPftBFCyEXO_454TV4C9_45JxB0Em91ySnfoMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: index2lmCnpqEr0q8Bo0U5PcmTBH_452orBO1CHqZ9vmd2u_S4Meta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93yF74OfhlvrAwLcm45_459fQjoihrzheGtZ_45QNjJxwd9GMMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93IPoVZWHEAk4hKczYboDMuqWDlyLnxb6XtG_EAA77dxkMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93MFs_bG5_SMKIE5Nu1uXZb5bnTOgf9sq3a6kcfOSEaloMeta || {},
    component: () => import("/var/www/2025-07-09_15_09/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-07-09_15_09/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-07-09_15_09/pages/shippingtypes/personalitemstransportation.vue")
  }
]